/** Tailwind class for the Sumana fallback font, used when no user-selected title font exists */
export const FALLBACK_DISPLAY_FONT_CLASS = 'font-display'
